import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

const TermsOfUse = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="container py-5">
      <div className="text-center mb-5" data-aos="fade-down">
        <h1 className="display-4 fw-bold text-dark">Terms of Use</h1>
        <p className="text-muted fs-5">
          Please read these terms carefully before using our website.
        </p>
      </div>

      <div className="row g-4">
        <div className="col-md-6" data-aos="fade-right">
          <div className="card border-0 shadow-sm h-100 hover-scale">
            <div className="card-body">
              <h3 className="card-title text-success mb-3">
                1. Use of Our Website
              </h3>
              <p className="card-text text-secondary">
                This website is intended for informational purposes regarding
                the services offered by IMT. Any unauthorized use of this
                website or its content is strictly prohibited.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6" data-aos="fade-left">
          <div className="card border-0 shadow-sm h-100 hover-scale">
            <div className="card-body">
              <h3 className="card-title text-success mb-3">
                2. Services and Information
              </h3>
              <p className="card-text text-secondary">
                IMT provides construction materials testing services to public
                and private industries. While we strive to keep information
                accurate and up-to-date, we do not guarantee its completeness or
                accuracy.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6" data-aos="fade-right">
          <div className="card border-0 shadow-sm h-100 hover-scale">
            <div className="card-body">
              <h3 className="card-title text-success mb-3">
                3. Intellectual Property
              </h3>
              <p className="card-text text-secondary">
                All content on this website, including text, images, and logos,
                is the property of IMT and is protected by copyright laws. You
                may not use, reproduce, or distribute any content without
                written permission.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6" data-aos="fade-left">
          <div className="card border-0 shadow-sm h-100 hover-scale">
            <div className="card-body">
              <h3 className="card-title text-success mb-3">
                4. Limitation of Liability
              </h3>
              <p className="card-text text-secondary">
                IMT is not liable for any direct, indirect, incidental, or
                consequential damages resulting from the use or inability to use
                our website or services.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6" data-aos="fade-right">
          <div className="card border-0 shadow-sm h-100 hover-scale">
            <div className="card-body">
              <h3 className="card-title text-success mb-3">
                5. Changes to Terms
              </h3>
              <p className="card-text text-secondary">
                We reserve the right to modify these terms at any time. Changes
                will be effective immediately upon posting on this page.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6" data-aos="fade-left">
          <div className="card border-0 shadow-sm h-100 hover-scale">
            <div className="card-body">
              <h3 className="card-title text-success mb-3">6. Contact Us</h3>
              <p className="card-text text-secondary">
                If you have any questions about these Terms of Use, please
                contact us at{" "}
                <a href="mailto:info@integrity-mt.com" className="text-success">
                  info@integrity-mt.com
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .hover-scale {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-scale:hover {
          transform: translateY(-5px) scale(1.02);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
        }
        .card-title {
          position: relative;
        }
        .card-title::after {
          content: "";
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 50px;
          height: 3px;
          background-color: #077325;
          border-radius: 2px;
        }
      `}</style>
    </div>
  );
};

export default TermsOfUse;
